module.exports = __webpack_public_path__ + "img/land_main_text.1de5dfcc.svg";